export default [
  {
    path: '/payment-sous-traitance',
    name: 'payment-sous-traitance-list',
    props: true,
    component: () => import('@/views/paymentSousTraitance/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Payment sous traitance',
      breadcrumb: [
        {
          text: 'Payment sous traitance',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/payment-sous-traitance/create',
    name: 'payment-sous-traitance-create',
    props: true,
    component: () => import('@/views/paymentSousTraitance/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Créer payment sous traitance',
      breadcrumb: [
        {
          text: 'Payment sous traitance',
          to: { name: 'payment-sous-traitance-list' },
        },
        {
          text: 'Créer',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/payment-sous-traitance/show/:id',
    name: 'payment-sous-traitance-detail',
    props: true,
    component: () => import('@/views/paymentSousTraitance/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détail payment sous traitance',
      breadcrumb: [
        {
          text: 'Payment sous traitance',
          to: { name: 'payment-sous-traitance-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
]
